import axios from "axios";
import * as ActionType from "./admin.type";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";
import { baseURL, secretKey } from "../../../util/config";

const token = sessionStorage.getItem("token");

export const signupAdmin = (signup, navigate) => async (dispatch) => {
  try {
    console.log("baseURL:", baseURL);
    console.log("URL:", `${baseURL}/admin/admin/create`);
    const res = await axios.post(`${baseURL}/admin/admin/create`, signup, {
      headers: { key: secretKey },
    });

    if (res.data.status) {
      dispatch({ type: ActionType.SIGNUP_ADMIN });
      setToast("success", "Signup Successfully!");

      navigate("/admin"); // SPA navigation
    } else {
      setToast("error", res.data.message);
    }

    return res;
  } catch (error) {
    setToast("error", error?.response?.data?.message || "Something went wrong");
    throw error;
  }
};

export const updateCode = (signup) => (dispatch) => {
  axios
    .patch(`${baseURL}/admin/admin/updateCode`, signup)
    .then((res) => {
      if (res.data.status) {
        setToast("success", "Purchase Code Update Successfully!");
        setTimeout(() => {
          window.location.href = "/login";
        }, 100);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error);
    });
};

export const loginAdmin = (login, navigate, onFinish) => async (dispatch) => {
  axios
    .post(`${baseURL}/admin/admin/login`, login, {
      headers: { key: secretKey },
    })
    .then((res) => {
      if (res.data.status) {
        console.log(res.data);
        dispatch({
          type: ActionType.LOGIN_ADMIN,
          payload: res.data?.token,
          data: res.data,
        });
        setToast("success", "Login Successfully!");
        // setTimeout(() => {
        navigate("/admin/mainDashboard");
        // }, 100);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error.response.data.message);
    })
    .finally(() => {
      // ✅ always called, success or fail
      if (onFinish) onFinish();
    });
};

export const getProfile = () => (dispatch) => {
  axios
    .get(`${baseURL}/admin/admin/profile`, {
      Headers: {
        authorization: token,
      },
    })
    .then((res) => {
      if (res.status) {
        dispatch({ type: ActionType.UPDATE_PROFILE, payload: res.data.user });
      } else {
        setToast("error", res.message);
      }
    })
    .catch((error) => {
      console.log("error", error.message);
    });
};

export const changePassword = (data) => (dispatch) => {
  axios
    .patch(`${baseURL}/admin/admin/updatePassword`, data)
    .then((res) => {
      if (res.data.status) {
        setToast("success", "Password Changed Successfully.");
        setTimeout(() => {
          dispatch({ type: ActionType.UNSET_ADMIN });
          window.location.href = "/login";
        }, [3000]);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => setToast("error", error.message));
};

export const profileUpdate = (formData) => (dispatch) => {
  axios
    .patch(`${baseURL}/admin/admin/updateProfile`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_PROFILE,
          payload: res.data.admin,
        });
        setToast("success", "Admin update Successfully");
      }
    })
    .catch((error) => {
      setToast("error", error);
    });
};

export const sendEmail = (login) => (dispatch) => {
  axios
    .post(`${baseURL}/admin/admin/forgotPassword`, login)
    .then((res) => {
      if (res.data.status) {
        setToast("success", "Email Send For Forget The Password! ");
        setTimeout(() => {
          window.location.href = "/";
        }, [2000]);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error.response.data.message);
    });
};

export const setPasswordApi = (login) => (dispatch) => {
  axios
    .post(`${baseURL}/admin/admin/setPassword`, login)
    .then((res) => {
      if (res.data.status) {
        setToast("success", "Password Changed Successfully.");
        setTimeout(() => {
          window.location.href = "/";
        }, [2000]);
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => {
      setToast("error", error.response.data.message);
    });
};

export const getAdminEarnings =
  (startDate, endDate, start, limit) => (dispatch) => {
    apiInstanceFetch
      .get(
        `${baseURL}/admin/premiumPlan/getpremiumPlanHistory?startDate=${startDate}&endDate=${endDate}&start=${start}&limit=${limit}`,
      )
      .then((res) => {
        if (res.status) {
          dispatch({
            type: ActionType.ADMIN_EARNING,
            payload: {
              earning: res.history,
              total: res.totalHistory,
              totalEarning: res.totalAdminEarnings,
            },
          });
        }
      });
  };

export const cleanData = () => (dispatch) => {
  dispatch({ type: ActionType.CLEAN_EARNING });
};

export const getCoinPlanEarnings =
  (startDate, endDate, start, limit) => (dispatch) => {
    apiInstanceFetch
      .get(
        `admin/coinPlan/retrieveUserCoinplanRecords?startDate=${startDate}&endDate=${endDate}&start=${start}&limit=${limit}`,
      )
      .then((res) => {
        if (res.status) {
          dispatch({
            type: ActionType.COIN_PLAN_EARNING,
            payload: {
              earning: res.data,
              total: res.total,
              totalEarning: res.totalAdminEarnings,
            },
          });
        }
      });
  };
